import { Button, Checkbox, Col, DatePicker, Form, Row, Select, Table } from 'antd';
import { useContext, useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { SocketContext } from '../../../App';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import arrayHandle from '../../../utils/baseLib/arrayHandle';

const { RangePicker } = DatePicker;

export default function ProductSaleDetail(props: any) {

    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);

    //表头
    const columnsHead = [
        {
            title: '日期',
            dataIndex: 'times',
            key: 'times',
            width: 110,
            onCell: (record: { dataNum: number; }) => ({
                rowSpan: record.dataNum,
            }),
            sortBy: 1,
            init: true
        },
        {
            title: '市别',
            dataIndex: 'sbName',
            key: 'sbName',
            onCell: (record: { dataNum: number; }) => ({
                rowSpan: record.dataNum,
            }),
            sortBy: 2,
            init: true
        },
        {
            title: '排队类型',
            dataIndex: 'queuingTypeName',
            key: 'queuingTypeName',
            sortBy: 3,
            init: true
        },
        {
            title: '取号桌数',
            dataIndex: 'totalNum',
            key: 'totalNum',
            sortBy: 4,
            init: true
        },
        {
            title: '就餐桌数',
            dataIndex: 'successNum',
            key: 'successNum',
            sortBy: 5,
            init: true
        },
        {
            title: '取消桌数',
            dataIndex: 'cancelNum',
            key: 'cancelNum',
            sortBy: 6,
            init: true
        },
        {
            title: '过号桌数',
            dataIndex: 'overNum',
            key: 'overNum',
            sortBy: 7,
            init: true
        },
        {
            title: '就餐率(桌)',
            dataIndex: 'successRate',
            key: 'successRate',
            render: (text: any) => {
                return (
                    <div>{text + " %"}</div>
                )
            },
            sortBy: 8,
            init: true
        },
        {
            title: '流失率(桌)',
            dataIndex: 'cancelRate',
            key: 'cancelRate',
            render: (text: any) => {
                return (
                    <div>{text + " %"}</div>
                )
            },
            sortBy: 9,
            init: true
        },
        {
            title: '取号人数',
            dataIndex: 'totalPersonNum',
            key: 'totalPersonNum',
            sortBy: 10,
            init: true
        },
        {
            title: '就餐人数',
            dataIndex: 'successPersonNum',
            key: 'successPersonNum',
            sortBy: 11,
            init: true
        },
        {
            title: '取消人数',
            dataIndex: 'cancelPersonNum',
            key: 'cancelPersonNum',
            sortBy: 12,
            init: false
        },
        {
            title: '过号人数',
            dataIndex: 'overPersonNum',
            key: 'overPersonNum',
            sortBy: 13,
            init: false
        },
        {
            title: '就餐率(人)',
            dataIndex: 'successPeopleRate',
            key: 'successPeopleRate',
            render: (text: any) => {
                return (
                    <div>{text + " %"}</div>
                )
            },
            sortBy: 14,
            init: false
        },
        {
            title: '流失率(人)',
            dataIndex: 'cancelPeopleRate',
            key: 'cancelPeopleRate',
            render: (text: any) => {
                return (
                    <div>{text + " %"}</div>
                )
            },
            sortBy: 15,
            init: false
        },
        {
            title: '线上取号',
            dataIndex: 'wxChannel',
            key: 'wxChannel',
            sortBy: 16,
            init: true
        },
        {
            title: '现场取号',
            dataIndex: 'branchStoreChannel',
            key: 'branchStoreChannel',
            sortBy: 17,
            init: true
        },
        {
            title: '平均等待(分钟)',
            dataIndex: 'waitTime',
            key: 'waitTime',
            sortBy: 18,
            init: true
        }
    ];

    let initHead = columnsHead.filter((item: any) => {
        if (item.init) {
            return item
        }
    })

    const [selectedColumns, setSelectedColumns] = useState(initHead);

    const [isAllSelected, setIsAllSelected] = useState(false);
    const [loading, setLoading] = useState(false);

    const [queuingTypeData, setQueuingTypeData] = useState<any>();

    const [rows, setRows] = useState<any>([]);

    const [sbData, setSbData] = useState<any>();

    const notificationApi = useNotificationInstance();
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        const fetchData = async () => {
            form.setFieldsValue({
                "chooseTime": [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')]
            })

            fetchApi.GET(wmService, {
                apiId: "queuingType",
                apiExtend: 'showList',
                apiData: {
                    branchStoreId: contextData?.currentBranchStoreId,
                    checkData: true,
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    }
                }
            }).then(res => {
                if (res.success) {
                    setQueuingTypeData(res.data);
                }
            });

            if (contextData?.currentBranchStoreId) {
                if (contextData?.refresh) {
                    await initArgument();
                }
                else {
                    await initArgument();
                }
            }
        }
        fetchData()
    }, [contextData?.currentBranchStoreId])

    const initArgument = async () => {
        let sb = await fetchApi.GET(wmService, {
            apiId: "sb",
            apiExtend: 'getBrandStoreIdToSb',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId
            }
        })

        if (sb.success) {
            setSbData(sb.data)
        }

        form.resetFields(["sbId"]);
        form.resetFields(["queuingTypeIds"]);
        setRows([]);
        setContextData({ ...contextData, refresh: false });
    }

    // const changeSb = (e: any, option: any) => {
    //     if (option?.children) {
    //         setSbName(option.children);
    //     }
    // }

    const onFinish = () => {
        setLoading(true);
        let branchStoreId = contextData?.currentBranchStoreId;
        if (!branchStoreId) {
            antMessage("error", '错误', "必须选择分店");
            return false;
        }
        form.validateFields()
            .then((values: any) => {
                fetchApi.GET(wmService, {
                    apiId: "queuingList",
                    apiExtend: 'queuingAnalysis',
                    apiData: {
                        ...values,
                        branchStoreId
                    }
                }).then((res) => {
                    if (res.success) {
                        // console.log(res.data);
                        setRows(res.data);
                        setLoading(false);
                        // setFilteredInfo({ productName: [] });
                    }
                }).catch((err) => {
                    showCustomNotification(notificationApi!, {
                        type: 'error',
                        message: '错误',
                        description: err,
                    });;
                })
            })
            .catch((err) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            })
    }
    const handleChange = (e: any, options: any) => {
        //按顺序重排，方便获取数据也是按顺序
        let sortData = arrayHandle.sort(options, "key", "asc");
        let finalData: Array<any> = [];
        for (var i = 0, len = sortData.length; i < len; i++) {
            finalData.push(sortData[i].value);
        }
        form.setFieldValue('queuingTypeIds', finalData);
    }

    const handleColumnToggle = (key: any) => {
        setSelectedColumns((prev: any) => {
            const newColumns = [...prev];
            const index = newColumns.findIndex(column => column.key === key);
            if (index > -1) {
                newColumns.splice(index, 1);
            } else {
                newColumns.push(columnsHead.find((column: any) => column.key === key));
            }
            setIsAllSelected(newColumns.length === columnsHead.length);
            return newColumns;
        });
    };

    const handleSelectAll = (e: any) => {
        setIsAllSelected(e.target.checked);
        setSelectedColumns(e.target.checked ? columnsHead : []);
    };

    return (
        <>
            <Row style={{ marginTop: 16 }}>
                <Col span={3}>
                    <Checkbox onChange={handleSelectAll} checked={isAllSelected}>
                        全选
                    </Checkbox>
                </Col>
                {columnsHead.map((column: any) => (
                    <Col key={column.key} span={3}>
                        <Checkbox
                            checked={selectedColumns.some((sc: any) => sc.key === column.key)}
                            onChange={() => handleColumnToggle(column.key)}
                        >
                            {column.title}
                        </Checkbox>
                    </Col>
                ))}
            </Row>
            <br></br>
            <Form
                form={form}
                onFinish={onFinish}
            >
                <Row>
                    <Col span={3}>
                        <Form.Item
                            label="市别"
                            name="sbId"
                        >
                            <Select
                                // onChange={changeSb}
                                allowClear
                                placeholder="市别"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}>
                                {getList.general(sbData, 'sbName')}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="排队类型"
                            name="queuingTypeIds"
                        >
                            <Select
                                allowClear
                                mode='multiple'
                                placeholder="排队类型"
                                onChange={(value, option) => handleChange(value, option)}
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}>
                                {getList.general(queuingTypeData, "queuingTypeName")}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="日期"
                            name="chooseTime"
                        >
                            <RangePicker
                                allowClear={false}
                                format="YYYY-MM-DD"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" disabled={loading}>统计</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <div style={{ marginTop: "20px" }}>
                <Table
                    scroll={{ x: "100%", y: 600 }}
                    bordered={true}
                    pagination={false}
                    rowKey={(record: any) => record.id}
                    // columns={columnsHead}
                    columns={arrayHandle.sort(selectedColumns, "sortBy", "asc")}
                    dataSource={rows}
                    loading={{
                        spinning: loading,
                        tip: '正在统计数据，请稍后...' // 自定义提示文字
                    }}
                // onChange={handleChange}
                >
                </Table>
            </div>
        </>
    )
}